module.exports = __webpack_public_path__ + "static/media/frames-7.cc0d0481.jpg";